import { useQuery } from '@tanstack/react-query';

import { getPage } from '../api/build-a-dash-api';
import type { Page } from '../components/PageConfigProvider/types';
import { usePageManager } from '../components/PageManagerProvider/PageManagerProvider';
import { getLocalReportTemplate } from '../templates/report-templates-registry';
import { pageQueryKeys } from './usePagesQuery';

export const useFetchPageConfig = (
  pageId: string
): { data: Page | undefined; isLoading: boolean } => {
  const { pages, loading } = usePageManager();

  const pageFromAllPages = pages?.find((p) => p.id === pageId);
  const reportTemplate = getLocalReportTemplate(pageId);

  const { data, isLoading } = useQuery<Page>({
    queryKey: pageQueryKeys.detail(pageId ?? ''),
    queryFn: () => getPage(pageId ?? ''),
    enabled: !loading && !pageFromAllPages && !reportTemplate,
    retry: 1,
    meta: { expectedErrorStatuses: [404] },
  });

  if (reportTemplate) {
    return { data: reportTemplate, isLoading: false };
  }

  if (loading) return { data: undefined, isLoading: true };

  if (pageFromAllPages) {
    return { data: pageFromAllPages, isLoading: false };
  }

  return { data, isLoading };
};
